import { useWorkspaceId } from "../../hooks/useWorkspaceId";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { useHttpTaxManagerAppHeaders } from "../utils/useHttpTaxManagerAppHeaders";
import { BASE_API_URL, HttpError } from "../utils/useTaxManagerAppQueryClient";
import type { TaxTinderSuggestionGroupDto } from "./TaxTinderSuggestionGroupDto";

export function useGetTaxTinderSuggestions() {
    const { t } = useTranslation();
    const workspaceId = useWorkspaceId();
    const headers = useHttpTaxManagerAppHeaders();

    const query = useQuery<TaxTinderSuggestionGroupDto[]>({
        queryKey: ["useGetTaxTinderSuggestions", workspaceId],
        queryFn: async () => {
            const response = await fetch(
                `${BASE_API_URL}/tenants/${workspaceId}/suggested-fulfilments`,
                { headers },
            );

            if (!response.ok) {
                throw new HttpError(response);
            }

            return response.json();
        },

        // Disable caching: gcTime (garbage collection time) and staleTime both set to 0
        // to ensure data is always fresh and immediately considered stale
        gcTime: 0,
        staleTime: 0,
        enabled: !!workspaceId,
        meta: {
            resourceName: t("errors.resourceName.suggestedFulfilments"),
        },
    });

    return query;
}
